export default {
  name: 'navbarStepper',
  props: {
    numberOfStep: {
      type: Number,
      default: 1,
      required: true
    },
    textOfStep: {
      type: String,
      default: 'Step',
      required: true
    },
    qaName: {
      type: String,
      required: false
    },
    handleClickBack: {
      type: Function,
      required: false
    },
    arrowIsAllow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleClickPrevPage () {
      if (this.handleClickBack) {
        this.handleClickBack()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
